import { useState } from "react";
import { useNavigate } from "react-router-dom";
import client, { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await client.post("/auth/login", form);
      localStorage.setItem("dic_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="bg-nero min-h-screen flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-nero-light border border-panna/10 p-8">
        <img src="/assets/logo-dark.png" alt="Dentro il Calice" className="h-16 w-auto mx-auto mb-8" />
        <h1 className="font-serif text-xl font-semibold text-panna text-center mb-6">Area riservata</h1>
        <input type="email" required placeholder="Email" data-testid="admin-email"
               value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
               className="w-full mb-4 rounded-lg px-4 py-3 bg-nero border border-panna/15 text-panna focus:outline-none focus:ring-2 focus:ring-oro/50" />
        <input type="password" required placeholder="Password" data-testid="admin-password"
               value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
               className="w-full mb-4 rounded-lg px-4 py-3 bg-nero border border-panna/15 text-panna focus:outline-none focus:ring-2 focus:ring-oro/50" />
        {error && <p data-testid="admin-login-error" className="text-sm text-oro-light mb-4">{error}</p>}
        <button type="submit" data-testid="admin-login-submit" disabled={loading}
                className="w-full rounded-full bg-bordeaux py-3.5 font-medium text-panna hover:bg-bordeaux-dark transition-colors disabled:opacity-60">
          {loading ? "Accesso…" : "Accedi"}
        </button>
      </form>
    </div>
  );
}
